import { FrameHistory } from '../models/manager-content-vehicle-history-drawer.model';
import { COLOR_HISTORY } from '../static/color-elements.static';

export interface PopupEndFrame {
  latitude: number;
  longitude: number;
  altitude?: number;
  speed?: number;
  direction?: number;
  date?: Date;
  reference?: string;
}

let popupIdCounter = 0;

export const createPopupEndFrame = (coords: PopupEndFrame) => {
  popupIdCounter++;
  const id = `popup-${popupIdCounter}`;
  const urlGoogleMaps = `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;
  const longitude = coords.longitude ? `${coords.longitude.toFixed(6)}°` : '0°';
  const latitude = coords.latitude ? `${coords.latitude.toFixed(6)}°` : '0°';
  const altitude = coords.altitude ? `${coords.altitude} m` : '0 m';
  const direction = coords.direction ? `${coords.direction}°` : '0°';
  const speed = coords.speed ? `${coords.speed} km/h` : '0 km/h';
  const date = coords.date
    ? new Date(coords.date)
        .toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
        .replace(',', '')
    : '00/00/0000 00:00:00';

  // IDs únicos para cada botón
  const ids = {
    pos: `${id}-pos-end`,
    alt: `${id}-alt-end`,
    dir: `${id}-dir-end`,
    speed: `${id}-speed-end`,
    date: `${id}-date-end`,
    reference: `${id}-reference-end`,
  };

  // Header tipo chip
  const header = `
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <div style="flex:1; display:flex; justify-content:center;">
        <span style="background:${COLOR_HISTORY.END_COLOR}11; color:${COLOR_HISTORY.END_COLOR}; font-weight:600; border-radius:12px; padding:4px 18px; font-size:13px; letter-spacing:1px; box-shadow:0 1px 4px #0001;">FIN DE RUTA</span>
      </div>
    </div>
  `;

  const popup = `
    ${header}
    <div id="${id}" style="font-family: 'Inter', Arial, sans-serif; font-size: 13px; color: #222;">

    <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 80px; min-width: 80px; width: 100%">Referencia:</span>
          <span style="min-width: 170px; max-width: 170px;" id="${
            ids.reference
          }-content">${
    // se utiliza varios puntos para recervar espacio para la direccion en caso sea muy grande
    coords.reference
      ? coords.reference
      : 'Buscando dirección ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ......'
  }</span>
          <span id="${
            ids.reference
          }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>

      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 80px; min-width: 80px; width: 100%">Posición:</span>
        <span id="${
          ids.pos
        }-content" style="min-width: 170px; color: #1976d2; text-decoration: underline; cursor: pointer;" onclick="window.open('${urlGoogleMaps}', '_blank')">${latitude}, ${longitude}</span>
        <span id="${
          ids.pos
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      ${
        altitude
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 80px; min-width: 80px; width: 100%">Altitud:</span>
          <span style="min-width: 170px;" id="${ids.alt}-content">${altitude}</span>
          <span id="${ids.alt}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        direction
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 80px; min-width: 80px; width: 100%">Dirección:</span>
          <div style="display: flex; align-items: center; gap: 8px; min-width: 170px;">
            <svg width="20" height="20" viewBox="0 0 24 24" style="transform: rotate(${
              coords.direction || 0
            }deg); transition: transform 0.3s ease;">
              <path fill="#ef4444" d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            <span id="${ids.dir}-content">${direction}</span>
          </div>
          <span id="${
            ids.dir
          }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        speed
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 80px; min-width: 80px; width: 100%">Velocidad:</span>
          <span style="min-width: 170px;" id="${ids.speed}-content">${speed}</span>
          <span id="${ids.speed}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        date
          ? `
        <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 80px; min-width: 80px; width: 100%">Fecha:</span>
          <span style="min-width: 170px;" id="${ids.date}-content">${date}</span>
          <span id="${ids.date}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
    </div>
  `;

  // Devuelve el HTML y los valores a copiar para el listener externo
  return {
    html: popup,
    ids,
    values: {
      pos: `${coords.latitude},${coords.longitude}`,
      alt: coords.altitude?.toString() ?? '',
      dir: coords.direction?.toString() ?? '',
      speed: coords.speed?.toString() ?? '',
      date: date ?? '',
    },
  };
};

export function adaptFrameHistoryToPopupEnd(
  frame: FrameHistory
): PopupEndFrame {
  return {
    latitude: parseFloat(frame.lat),
    longitude: parseFloat(frame.lng),
    altitude: frame.altitude,
    direction: frame.angle,
    speed: frame.speed,
    date: new Date(frame.dt_tracker),
    reference: frame.reference ?? undefined,
  };
}
